import React, {useEffect, useState} from 'react';
import {STEP, STEP_VALUE} from '../../system/defaults';
import {formatCurrency} from '../../_utilities/formattingUtils';

export default function TicketEstimate({ticket, groupId, ticketCost, saving, onSave, onEditingChange, onError}) {
    const [editing, setEditing] = useState(false);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const required = ticket.estimate_required === '1';
    useEffect(() => {
        if (required && ticket.estimated_time === '0' && groupId === '1') {
            setEditing(true);
            onEditingChange(true);
        }
    }, [required, ticket.estimated_time, groupId, onEditingChange]);
    if (!required) return null;
    const begin = () => {
        const totalMinutes = Number(ticket.estimated_time || 0) * STEP;
        setHours(Math.floor(totalMinutes / 60));
        setMinutes(totalMinutes % 60);
        setEditing(true);
        onEditingChange(true);
    };
    const close = () => { setEditing(false); onEditingChange(false); };
    const save = async () => {
        const hourValue = Number(hours);
        const minuteValue = Number(minutes);
        if (hours === '' || minutes === '' || !Number.isInteger(hourValue) || hourValue < 0 || hourValue > 8 ||
            !Number.isInteger(minuteValue) || minuteValue < 0 || minuteValue >= 60 || minuteValue % STEP !== 0) {
            onError('Enter 0–8 whole hours and minutes in valid billing increments.');
            return;
        }
        if (await onSave('estimated_time', String((hourValue * 60 + minuteValue) / STEP))) close();
    };
    return groupId === '1' ? <>
        Set Estimate:
        {!editing ? <div className="mb-3 d-flex">
            <input className="form-control me-2" value={formatCurrency(Number(ticket.estimated_time) * STEP_VALUE)} disabled/>
            <button className="btn btn-warning" disabled={saving} onClick={begin}>Update</button>
        </div> : <div className="mb-3">
            <div className="d-flex justify-content-between">
                <label htmlFor="estimate-hour" className="me-2">Hours
                    <input type="number" id="estimate-hour" className="form-control" value={hours}
                        disabled={saving} onChange={event => setHours(event.target.value)} min={0} max={8}/>
                </label>
                <label htmlFor="estimate-min" className="me-2">Minutes
                    <input type="number" id="estimate-min" className="form-control" value={minutes}
                        disabled={saving} onChange={event => setMinutes(event.target.value)} min={0} max={60 - STEP} step={STEP}/>
                </label>
            </div>
            <button className="btn btn-success mt-2" disabled={saving} onClick={save}>Save</button>
            <button className="btn btn-danger mt-2 ms-2" disabled={saving} onClick={close}>Cancel</button>
        </div>}
    </> : <>
        Estimated / Actual Cost:
        {Number(ticket.estimated_time) > 0 ? <div className="mb-3 d-flex">
            <input className="form-control me-2"
                value={`${formatCurrency(Number(ticket.estimated_time) * STEP_VALUE)} / ${ticketCost}`} disabled/>
            {ticket.estimate_approved === '-1' &&
                <button className="btn btn-success" disabled={saving} onClick={() => onSave('estimate_approved', '1')}>Accept</button>}
        </div> : <input className="form-control me-2" value="Pending estimate..." disabled/>}
    </>;
}
